import { Routes } from '@angular/router';

export const routes: Routes = [
  // La raiz del app de clientes entra al marketplace (e-service).
  // pathMatch:'full' -> solo la URL vacia redirige; /dashboard, /mis-puntos, etc.
  // los sigue sirviendo PagesModule mas abajo.
  {
    path: '',
    redirectTo: 'marketplace',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./public-pages/public-child-routes.routes').then(
        (m) => m.publicChildRoute
      ),
  },
  {
    path: 'marketplace',
    loadChildren: () =>
      import('./marketplace/marketplace.routes').then((m) => m.marketplaceRoutes),
  },
  // Los legales tambien cuelgan de la raiz, ademas de /public/*. Dos razones: en la ficha
  // de Google Play se lee mejor auracentromedico.com/politica-de-privacidad, y la app ya
  // publicada lleva esa URL adentro del binario — un cambio de path aca dejaria enlaces
  // muertos en telefonos que no se pueden actualizar de un dia para el otro.
  {
    path: 'politica-de-privacidad',
    loadComponent: () =>
      import('./public-pages/legales/legales.component').then((m) => m.LegalesComponent),
    data: { documento: 'privacidad' },
    title: 'Política de Privacidad · Aura',
  },
  {
    path: 'terminos-y-condiciones',
    loadComponent: () =>
      import('./public-pages/legales/legales.component').then((m) => m.LegalesComponent),
    data: { documento: 'terminos' },
    title: 'Términos y Condiciones · Aura',
  },
  {
    // Baja de cuenta sin la app: Google Play la exige como "URL de eliminación de cuenta".
    path: 'eliminar-cuenta',
    loadComponent: () =>
      import('./public-pages/eliminar-cuenta/eliminar-cuenta.component').then((m) => m.EliminarCuentaComponent),
    title: 'Eliminar tu cuenta · Aura',
  },
  {
    // App Store Connect exige una URL de soporte con contacto real.
    path: 'soporte',
    loadComponent: () =>
      import('./public-pages/soporte/soporte.component').then((m) => m.SoporteComponent),
    title: 'Soporte · Aura',
  },
  {
    // Enlace de invitación que comparte la app (SPEC-036). Corto a propósito: viaja en
    // un WhatsApp o un SMS.
    path: 'r/:codigo',
    loadComponent: () =>
      import('./public-pages/invitacion/invitacion.component').then((m) => m.InvitacionComponent),
    title: 'Te invitaron a Aura',
  },
  {
    // Libro de reclamaciones de cada negocio (SPEC-037). La app lo abre en un webview
    // con ?app=1; ?sede=<slug> preselecciona la sede.
    path: 'reclamos/:marca',
    loadComponent: () =>
      import('./public-pages/libro-negocio/libro-negocio.component').then((m) => m.LibroNegocioComponent),
    title: 'Libro de Reclamaciones · Aura',
  },
  {
    // Campañas (Black Friday y demás), definidas en campanas/campanas.data.ts. La app las
    // abre en un webview con ?app=1 desde un anuncio; cambiarlas no espera a las tiendas.
    path: 'campanas/:slug',
    loadComponent: () => import('./campanas/campana.component').then((m) => m.CampanaComponent),
    title: 'Campañas · Aura',
  },
  {
    // Ruta desconocida en el app de clientes -> al marketplace (no dejar un 404 muerto).
    path: '**',
    redirectTo: 'marketplace',
  },
];
